import { render } from "./NavButtons.vue?vue&type=template&id=ee3f8ffc"
import script from "./NavButtons.vue?vue&type=script&lang=ts"
export * from "./NavButtons.vue?vue&type=script&lang=ts"
script.render = render

export default script